export default __webpack_public_path__ + "images/e77f4a328e9fe6b7c310f56f55ca5708.png";